import React from 'react';
import { Check, X } from 'lucide-react';

const ROWS = [
  { dim: 'Authenticity & trust',  freddy: 'Real execs in your ICP vouching',         ads: 'Paid interruption' },
  { dim: 'Reach',                 freddy: 'Organic + endorsed',                       ads: 'Paid' },
  { dim: 'Cost per impression',   freddy: 'Affordable — pay per deliverable',         ads: 'Expensive — $33.80 LinkedIn CPM' },
  { dim: 'Audience experience',   freddy: 'Welcome — comes from a trusted voice',     ads: 'Negative — interrupts the feed' },
  { dim: 'Human connection',      freddy: 'Direct from operator to operator',         ads: 'Brand-to-stranger' },
  { dim: 'Storytelling potential',freddy: 'Massive — full posts, calls, video',       ads: 'Limited — 150 chars + CTA' },
  { dim: 'Buyer intent signal',   freddy: 'Pre-qualified — exec already in your ICP', ads: 'Cold — broad demographic targeting' },
];

export default function CompareTable() {
  return (
    <section className="py-24 sm:py-32 border-t border-white/5" data-testid="compare-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[10px] sm:text-xs font-mono uppercase tracking-[0.3em] text-[#FF4343] mb-3">★ Ditch ads, build trust ★</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Why exec endorsements <span className="text-[#FF4343]">win</span>.
          </h2>
        </div>

        <div className="overflow-x-auto bg-[#111827] border border-white/10">
          <table className="w-full text-sm" data-testid="compare-table">
            <thead>
              <tr className="border-b border-white/10">
                <th className="text-left px-4 sm:px-6 py-4 sm:py-5 text-[10px] sm:text-xs font-mono uppercase tracking-wider text-[#6B7280]">Category</th>
                <th className="text-left px-4 sm:px-6 py-4 sm:py-5 text-xs sm:text-sm font-display font-bold text-[#FF4343]">
                  <Check className="w-4 h-4 inline mr-1.5 -mt-0.5" />
                  Freddy Leads
                </th>
                <th className="text-left px-4 sm:px-6 py-4 sm:py-5 text-xs sm:text-sm font-display font-bold text-[#6B7280]">
                  <X className="w-4 h-4 inline mr-1.5 -mt-0.5" />
                  Paid ads
                </th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r, i) => (
                <tr key={i} className="border-b border-white/5 last:border-b-0 hover:bg-white/[0.02]" data-testid={`compare-row-${i}`}>
                  <td className="px-4 sm:px-6 py-4 text-[11px] sm:text-sm text-white font-medium">{r.dim}</td>
                  <td className="px-4 sm:px-6 py-4 text-[11px] sm:text-sm text-[#9CA3AF]">
                    <span className="inline-block w-2 h-2 rounded-full bg-[#FF4343] mr-2"></span>
                    {r.freddy}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[11px] sm:text-sm text-[#6B7280] italic">{r.ads}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
